export const environment = {
  production: false,
  authApiUrl: 'https://staging-app.sndbxvillage.com/api/auth',
  expertApiUrl: 'https://staging-app.sndbxvillage.com/api/expert',
  auditApiUrl: 'https://staging-app.sndbxvillage.com/api/audit',
  ticketingApiUrl: 'https://staging-app.sndbxvillage.com/api/ticketing',
  countryOptions: [
    { value: 'KE', label: 'Kenya' },
    { value: 'ET', label: 'Ethiopia' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'ZA', label: 'South Africa' },
    { value: 'TZ', label: 'Tanzania' },
    { value: 'UG', label: 'Uganda' },
    { value: 'US', label: 'United States' },
    { value: 'GB', label: 'United Kingdom' },
  ],
};
